angular.module('lsnBase.deprecated.models')
  .factory('UnderwriterModel', ['LsnUnderwriterModelV1',
    function(LsnUnderwriterModelV1) {
      return LsnUnderwriterModelV1;
    }
  ]);